<template>
    <sidebar-shell
        :sidebarVisible="sidebarVisible"
        :collapsed="collapsed"
        home-to="/workspace/dashboard"
        @toggle-sidebar="$emit('toggle-sidebar', $event)"
        @toggle-menu-collapsed="$emit('toggle-menu-collapsed', $event)"
    ></sidebar-shell>
</template>

<script>
import SidebarShell from "@/components/layout/shared/sidebar-shell";

export default {
    name: "sidebar",
    components: {SidebarShell},
    emits: ['toggle-sidebar', 'toggle-menu-collapsed'],
    props: {
        sidebarVisible: {
            type: Boolean,
            required: true,
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
}
</script>
